import { render } from "./ShowUserInvitationLink.vue?vue&type=template&id=44a72804"
import script from "./ShowUserInvitationLink.vue?vue&type=script&lang=js"
export * from "./ShowUserInvitationLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__